document.addEventListener("DOMContentLoaded", () => {
  const inserts = document.querySelectorAll('.insert');

  const updateParallax = () => {
    const windowHeight = window.innerHeight;

    inserts.forEach(insert => {
      const img = insert.querySelector('img');
      if (!img) return;

      const rect = insert.getBoundingClientRect();
      if (rect.top < windowHeight && rect.bottom > 0) {
        const progress = (windowHeight - rect.top) / (windowHeight + rect.height);
        const move = (progress - 0.5) * 80;
        img.style.transform = `translateY(${move}px) scale(1.2)`;
      }
    });
  };

  window.addEventListener('scroll', updateParallax);
  window.addEventListener('resize', updateParallax);
  updateParallax();
});
